<template>
    <div
        class="not-certified-wrap"
        :class="{ 'scene-new-enterprise': certScene === 'newEnterprise' }"
    >
        <div class="not-certified-content">
            <div class="page-title">
                <span v-if="certScene === 'newEnterprise'" class="new-enterprise-title">认证新企业</span>
                <span v-else>您尚未升级成为企业用户{{ isPersonalCertified ? '' : '，目前请先进行个人认证' }}</span>
            </div>
            
            <div class="upgrade-container">
                <!-- 左侧：个人用户 -->
                <div v-if="certScene !== 'newEnterprise'" class="user-panel individual-panel">
                    <div class="panel-header">个人用户</div>
                    <div class="user-icon individual-icon">
                        <span class="icon-text">个人</span>
                    </div>
                    <div v-if="isPersonalCertified">
                        <div class="user-name">{{ userInfo.name || '名称' }}</div>
                        <div class="user-phone">{{ formatPhone(userInfo.phone) || '---' }}</div>
                    </div>
                    <div v-else>
                        <Button type="primary" size="large" class="certify-btn" @click="goToPerson">
                            个人认证
                        </Button> 
                    </div>
                </div>

                <!-- 中间：升级箭头 -->
                 <div v-if="certScene !== 'newEnterprise'" class="upgrade-arrow-section"> 
                    <Icon type="ios-arrow-forward" class="arrow-icon" />  
                    <div class="upgrade-text">升级为企业</div>
                </div>

                <!-- 右侧：企业用户 -->
                <div class="user-panel enterprise-panel"> 
                    <div class="panel-header">企业用户</div>
                    <div class="user-icon enterprise-icon"  
                        :style="{ background: isPersonalCertified ? '#4877E8' : '#aeb7c4', color: isPersonalCertified ? '#fff' : '#fff' }">
                        <!-- :style="{ color: isPersonalCertified ? '#fff' : '#fff' }" -->
                        <span class="icon-text" >企业</span>
                    </div> 
                    <!-- && newEnterpriseCertType == 'info' -->
                    <Button type="primary" :disabled="certScene !== 'newEnterprise' && !isPersonalCertified " 
                    :style="{ background: isPersonalCertified ? '#4877E8' : '#aeb7c4', color: isPersonalCertified ? '#fff' : '#fff' }"
                     size="large" class="certify-btn" @click="goToCertify">
                        {{ certScene === 'newEnterprise' ? '认证新企业' : '企业认证' }}
                    </Button>
                </div>
            </div>
        </div>        

        <!-- 弹窗1：组织机构认证（输入单位名称） -->
        <Modal
            v-model="showOrgCertifyModal"
            :mask-closable="false"
            title="组织机构认证"
            width="580"
            class-name="org-certify-modal"
            @on-cancel="closeOrgCertifyModal"
        >
            <div class="org-certify-content">
                <div class="org-certify-desc">
                    认证通过后，将由您作为本单位的系统管理员，负责维护系统内部的管理权限
                </div>

                <div class="org-certify-box">
                    <div class="org-certify-box-title">
                        请输入您要认证的单位名称，需保证与营业执照上的名称一致
                    </div>
                    <Form ref="orgCertifyForm" :model="orgCertifyData" :rules="orgCertifyRules" :label-width="0">
                        <FormItem prop="orgName">
                            <Input
                                v-model="orgCertifyData.orgName"
                                placeholder="请输入"
                                size="large"
                                @on-change="onOrgNameInputChange"
                                @on-blur="handleOrgNameBlur(orgCertifyData.orgName)"
                            />
                        </FormItem>
                        <div v-if="existCheck.orgName.isExist && existCheck.orgName.msg" class="exist-tip" style="margin-top: 8px;margin-left: 8px; text-align: left;">
                            {{ existCheck.orgName.msg }}
                        </div>
                    </Form>
                </div>
            </div>
            <div slot="footer" class="modal-footer-custom" style="padding:12px 24px;">
                <Button @click="closeOrgCertifyModal" size="small" class="cancel-btn">取消</Button>
                <Button 
                    type="primary" 
                    @click="nextToStep2" 
                    :loading="existCheckLoading"
                    :disabled="!orgCertifyData.orgName || existCheck.orgName.isExist || existCheckLoading"
                    class="confirm-btn"
                    size="small"
                >
                    下一步
                </Button>
            </div>
        </Modal>

        <!-- 弹窗2：组织机构认证授权表单 -->
        <Modal
            v-model="showAuthFormModal"
            :mask-closable="false"
            title="组织机构认证授权"
            width="680"
            class-name="auth-form-modal"
            @on-cancel="closeAuthFormModal"
        >
            <div class="auth-form-content">
                <!-- 组织类型 -->
                <div class="form-section">
                    <div class="section-title">组织类型</div>
                    <div class="option-group">
                        <div 
                            class="option-item" 
                            :class="{ active: formData.orgType === 'enterprise' }"
                            @click="formData.orgType = 'enterprise'"
                        >
                            企业
                        </div>
                        <div 
                            class="option-item" 
                            :class="{ active: formData.orgType === 'individual' }"
                            @click="formData.orgType = 'individual'"
                        >
                            个体工商户
                        </div>
                    </div>
                </div>
                

                <!-- 认证方式 -->
                <div class="form-section">
                    <div class="section-title">认证方式</div>
                    <div class="option-group">
                        <div 
                            class="option-item" 
                            :class="{ active: formData.authMethod === 'legal' }"
                            @click="formData.authMethod = 'legal'"
                        >
                            法定代表人
                        </div>
                    </div>
                </div>

                <!-- 填写组织信息 -->
                <div class="form-section">
                    <div class="section-title">填写组织信息</div>
                    <Form ref="authForm" :model="formData" :rules="formRules" :label-width="140">
                        <!-- 营业执照 -->
                        <FormItem v-if="showLicense" label="营业执照:" prop="license"> 
                            <div class="license-upload-wrap">
                                <div class="license-left">
                                    <div v-if="licenseOcrLoading" class="license-ocr-loading">
                                        <div class="dots"><span></span><span></span><span></span></div>
                                        <div class="txt">识别中...</div>
                                    </div>
                                    <div v-if="formData.license" class="license-preview">
                                        <img class="license-img" :src="formData.license" alt="营业执照" @error="handleImageError" />
                                        <div class="license-actions">
                                            <Upload
                                                :show-upload-list="false"
                                                :headers="headers"
                                                :action="licenseOcrAction"
                                                :format="['jpg', 'jpeg', 'png']"
                                                :before-upload="beforeLicenseOcrUpload"
                                                :on-success="onLicenseUploadSuccess"
                                                :on-error="onLicenseOcrError"
                                                :on-format-error="onLicenseFormatError"
                                            >
                                                <Button size="small" type="primary" :disabled="licenseOcrLoading">重新上传</Button>
                                            </Upload>
                                            <Button size="small" style="margin-left: 8px" :disabled="licenseOcrLoading" @click="previewLicense">预览</Button>
                                            <Button size="small" style="margin-left: 8px" type="error" ghost :disabled="licenseOcrLoading" @click="removeLicense">删除</Button>
                                        </div>
                                    </div>
                                    <div v-else class="license-empty">
                                        <Upload
                                            :show-upload-list="false"
                                            :headers="headers"
                                            :action="licenseOcrAction"
                                            :format="['jpg', 'jpeg', 'png']"
                                            :before-upload="beforeLicenseOcrUpload"
                                            :on-success="onLicenseUploadSuccess"
                                            :on-error="onLicenseOcrError"
                                            :on-format-error="onLicenseFormatError"
                                            :disabled="licenseOcrLoading"
                                        >
                                            <div class="license-uploader">
                                                <div class="plus">+</div>
                                                <div class="tips">点击上传</div>
                                            </div>
                                        </Upload>
                                    </div>
                                    <!-- <div class="license-remind">
                                        请上传彩色原件或加盖公司公章的复印件
                                    </div> -->
                                </div>
                                <div class="license-right">
                                    <a class="license-example" href="#" @click.prevent="openLicenseExample">示例</a>
                                    <div class="license-desc">请上传彩色原件或加盖公司公章的复印件</div>
                                </div>
                            </div>
                        </FormItem>
                        <FormItem label="组织机构名称:" prop="orgName">
                            <Input 
                                v-model="formData.orgName" 
                                placeholder="请输入组织机构名称"
                                :maxlength="100"
                                style="width: 300px;"
                                :disabled="orgNameLocked"
                                :class="{ 'locked-input': orgNameLocked }"
                                @on-change="clearExistCheck('orgName')"
                                @on-blur="handleOrgNameBlur(formData.orgName)"
                            />
                        </FormItem>
                        <div v-if="existCheck.orgName.isExist && existCheck.orgName.msg" class="exist-tip" style="margin-left: 140px;">
                            {{ existCheck.orgName.msg }}
                        </div>
                        <FormItem label="统一社会信用代码:" prop="creditCode">
                            <Input 
                                v-model="formData.creditCode" 
                                placeholder="请输入统一社会信用代码"
                                :maxlength="18"
                                style="width: 300px;"
                                @on-change="clearExistCheck('creditCode')"
                                @on-blur="handleCreditCodeBlur"
                            />
                        </FormItem>
                        <div v-if="existCheck.creditCode.isExist && existCheck.creditCode.msg" class="exist-tip" style="margin-left: 140px;">
                            {{ existCheck.creditCode.msg }}
                        </div>
                        <FormItem label="法定代表人:" prop="legalPerson">
                            <Input 
                                v-model="formData.legalPerson" 
                                placeholder="请输入法人代表人名称"
                                :maxlength="50"
                                style="width: 300px;"
                            />
                        </FormItem>
                        <FormItem label="法人身份证号:" prop="legalIdCard">
                            <Input 
                                v-model="formData.legalIdCard" 
                                placeholder="请输入法人身份证号"
                                :maxlength="18"
                                style="width: 300px;"
                            />
                        </FormItem>
                    </Form>
                </div>

                <!-- 认证授权 -->
                <div class="form-section">
                    <div class="section-title">认证授权</div>
                    <Form ref="authForm2" :model="formData" :rules="formRules" :label-width="140">
                        <FormItem label="授权范围:" prop="authScope">
                            <Input 
                                v-model="formData.authScope" 
                                placeholder="速速云签平台"
                                readonly
                                style="width: 300px;"
                            />
                        </FormItem>
                        <FormItem label="授权期限:" prop="authPeriod">
                            <Select
                                v-model="formData.authPeriod"
                                class="auth-period-select"
                                placeholder="请选择授权期限"
                                @on-change="onAuthPeriodChange"
                                style="width: 300px;"
                            >
                                <Option value="longterm">长期有效</Option>
                                <Option value="nonlongterm">非长期有效</Option>
                            </Select>
                            <FormItem 
                                v-if="formData.authPeriod === 'nonlongterm'" 
                                prop="authEndDate" 
                                :label-width="0"
                                style="margin-top: 16px;"
                            >
                                <DatePicker 
                                    :value="formData.authEndDate"
                                    type="date" 
                                    placeholder="请选择授权结束日期"
                                    :options="datePickerOptions" 
                                    format="yyyy-MM-dd"
                                    @on-change="handleAuthEndDateChange"
                                    style="width: 300px;"
                                />
                            </FormItem>
                        </FormItem>
                    </Form>
                </div>
                
                <!-- 认证授权 + 打款验证-->
                <div class="form-section auth-pay-section">
                    <!-- <div class="section-title">
                        上传授权书
                        <span style="color: #999; font-size: 12px;">需要组织签婆摄权书同意你的申请</span>
                        <a class="download-link" href="#" @click.prevent="downloadAuthBookTemplate">下载授权书</a>
                    </div>
                    <div class="authbook-upload-row">
                        <div class="authbook-left">
                            <div v-if="formData.authBook" class="authbook-preview">
                                <img class="authbook-img" :src="formData.authBook" alt="授权书" />
                                <div class="authbook-actions">
                                    <Upload
                                        :show-upload-list="false"
                                        :headers="headers"
                                        :action="imageAction"
                                        :format="['jpg', 'jpeg', 'png']"
                                        :on-success="onAuthBookUploadSuccess"
                                        :on-format-error="onAuthBookFormatError"
                                    >
                                        <Button size="small" type="primary">重新上传</Button>
                                    </Upload>
                                    <Button size="small" style="margin-left: 8px" @click="previewAuthBook">预览</Button>
                                    <Button size="small" style="margin-left: 8px" type="error" ghost @click="removeAuthBook">删除</Button>
                                </div>
                            </div>
                            <div v-else class="authbook-empty">
                                <Upload
                                    :show-upload-list="false"
                                    :headers="headers"
                                    :action="imageAction"
                                    :format="['jpg', 'jpeg', 'png']"
                                    :on-success="onAuthBookUploadSuccess"
                                    :on-format-error="onAuthBookFormatError"
                                >
                                    <div class="authbook-uploader">
                                        <div class="plus">+</div>
                                    </div>
                                </Upload>
                            </div>
                        </div>
                        <div class="authbook-tip">授权书个人工审核(1-3天)</div>
                    </div> -->

                    <!-- <div class="section-title" style="margin-top: 22px;">打款验证</div>
                    <div class="pay-verify-wrap">
                        <RadioGroup v-model="formData.payVerifyWay" class="pay-verify-radio" style="margin-left: 60px;">
                            <Radio label="company_pay_to_me">我司向xxx打款</Radio>
                            <Radio label="me_pay_to_company">xxx向我司打款</Radio>
                        </RadioGroup>
                        <div class="pay-verify-desc" style="margin-left: 60px;">
                            请向xxx账户打款，检测到您公司的打款流水后自动通过认证
                            <span class="pay-verify-note">（若未按该账户打款汇入一笔随机金额，则随机金额验证可通过认证）</span>
                        </div> 
                        <div v-if="formData.payVerifyWay === 'company_pay_to_me'" class="pay-info-card">
                            <div class="pay-info-row"><span class="k">账户名称</span><span class="v">{{ payInfo.accountName }}</span></div>
                            <div class="pay-info-row"><span class="k">开户银行</span><span class="v">{{ payInfo.openBank }}</span></div>
                            <div class="pay-info-row"><span class="k">银行账号</span><span class="v">{{ payInfo.bankNo }}</span></div>
                            <div class="pay-info-row"><span class="k">联行号</span><span class="v">{{ payInfo.unionBankNo }}</span></div>
                            <div class="pay-info-row"><span class="k">点击下载</span><span class="v"><a href="#" @click.prevent="downloadPayInfoFile">{{ payInfo.downloadName }}</a></span></div>
                            <div class="pay-info-row"><span class="k">汇款备注</span><span class="v">{{ payInfo.remark }}</span></div>
                            <div class="pay-info-row amount"><span class="k">汇款金额</span><span class="v">¥{{ payInfo.amount }}</span></div>
                        </div>
 
                        <div v-else class="pay-form">
                            <Form :model="formData" :label-width="150">
                                <FormItem label="账户名称:" required>
                                    <Input v-model="formData.payAccountName" placeholder="企业名称" style="width: 300px;" />
                                </FormItem>
                                <FormItem label="开户银行:" required>
                                    <Input v-model="formData.payOpenBank" placeholder="请输入开户银行" style="width: 300px;" />
                                </FormItem>
                                <FormItem label="银行账号:" required>
                                    <Input v-model="formData.payBankNo" placeholder="请输入银行卡号" style="width: 300px;" />
                                </FormItem>
                            </Form>
                        </div>
                    </div> -->
                </div>

                <!-- 协议复选框 -->
                <div class="agreement-section" style="padding-bottom: 24px;">
                    <Checkbox v-model="formData.agreed">
                        <span>我已仔细阅读并充分理解</span>
                        <a href="#" @click.prevent="showPrivacyPolicy">《隐私政策》</a>
                        <span>、</span>
                        <a href="#" @click.prevent="showCertificateAgreement">《数字证书使用协议》</a>
                        <span>，且同意申请数字证书</span>
                    </Checkbox>
                </div>
            </div>
            <div slot="footer" class="modal-footer-custom">
                <Button @click="closeAuthFormModal" size="small" class="cancel-btn">取消</Button>
                <Button @click="prevToStep1" size="small" class="prev-btn">上一步</Button>
                <Button 
                    type="primary" 
                    @click="nextToStep3" 
                    :disabled="!canGoNext || existCheck.orgName.isExist || existCheck.creditCode.isExist"
                    class="confirm-btn"
                    size="small"
                >
                    下一步
                </Button>
            </div>
        </Modal>

        <Modal
            v-model="showImageModal"
            :mask-closable="false"
            title="组织机构认证授权协议书"
            width="900"
            class-name="image-view-modal"
            @on-cancel="closeImageModal"
        >
            <div class="image-view-content">
                <div class="image-list" v-if="imageList.length > 0">
                    <div
                        class="image-item"
                        v-for="(img, pageIndex) in imageList"
                        :key="pageIndex"
                    >
                        <div class="image-page-wrapper">
                            <img :src="img" alt="认证图片" @error="handleImageError" />
                            <!-- 叠加组件内容：根据 assemblyArr 中的 page、position_x、position_y、font_size 等定位 -->
                            <div
                                v-for="(field, fIndex) in getAssemblyByPage(pageIndex + 1)"
                                :key="fIndex"
                                class="assembly-field"
                                :style="getAssemblyStyle(field)"
                            >
                                {{ field.value }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-image" v-else>
                    <Icon type="ios-image-outline" size="48" />
                    <p>暂无图片</p>
                </div>
            </div>
            <div slot="footer" class="modal-footer-custom">
                <Button @click="closeImageModal" size="small" class="cancel-btn">取消</Button>
                <!-- <Button @click="prevToStep2" size="small" class="prev-btn">上一步</Button> -->
                <Button 
                    type="primary" 
                    @click="submitAuth" 
                    class="confirm-btn"
                    size="small"
                >
                    同意
                </Button>
            </div>
        </Modal>

        <!-- 协议图片弹窗（新） -->
        <Modal
            v-model="showAgreementModal"
            :mask-closable="false"
            title="协议内容"
            width="900"
            class-name="agreement-image-modal"
        >
            <div class="image-view-content">
                <div class="image-list" v-if="agreementImageList.length > 0">
                    <div
                        class="image-item"
                        v-for="(img, index) in agreementImageList"
                        :key="index"
                    >
                        <img :src="img" style="width: 800px; height: 1132px;" alt="协议图片" @error="handleImageError" />
                    </div>
                </div>
                <div class="empty-image" v-else>
                    <Icon type="ios-image-outline" size="48" />
                    <p>暂无图片</p>
                </div>
            </div>
            <div slot="footer" class="modal-footer-custom">
                <Button @click="closeAgreementModal" size="small" class="cancel-btn">关闭</Button>
            </div>
        </Modal>

        <!-- 营业执照示例弹窗（可选：有资源时展示） -->
        <Modal
            v-model="showLicenseExampleModal"
            :mask-closable="true"
            title="营业执照示例"
            width="720"
            class-name="license-example-modal"
        >
            <div style="text-align:center;">
                <img v-if="licenseExampleUrl" :src="licenseExampleUrl" alt="营业执照示例" style="max-width: 100%; max-height: 70vh;" />
                <div v-else style="padding: 24px 0; color: #999;">暂无示例图片</div>
            </div>
            <div slot="footer" class="modal-footer-custom">
                <Button @click="showLicenseExampleModal = false" size="small" class="cancel-btn">关闭</Button>
            </div>
        </Modal>

        <!-- 弹窗4：授权进度详情 -->
        <Modal
            v-model="showAuthProgressModal"
            :mask-closable="false"
            title="组织机构认证授权"
            width="760"
            class-name="auth-progress-modal"
            @on-cancel="closeAuthProgressModal"
             :footer-hide="true"
        >
            <div class="auth-progress-content">
                <div class="info-list">
                    <div class="info-item">
                        <span class="label">组织类型:</span>
                        <span class="value">{{ authProgressData.type === 1 ? '企业' : '个体工商户' || '--' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">认证方式:</span>
                        <span class="value">{{ '法定代表人'}}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">组织机构名称:</span>
                        <span class="value">{{ authProgressData.prise_name || '--' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">统一社会信用代码:</span>
                        <span class="value">{{ authProgressData.credit_code || '--' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">法定代表人:</span>
                        <span class="value">{{ authProgressData.real_name || '--' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">法人身份证号:</span>
                        <span class="value">{{ authProgressData.id_card || '--' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">授权范围:</span>
                        <span class="value">{{ '速速云签平台' || '--' }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">授权期限:</span>
                        <span class="value">{{ authProgressData.is_auth_limit === 1 ? authProgressData.auth_deadline : '长期有效' || '--' }}</span>
                    </div>
                </div>
                <div class="link-section">
                    <p class="copy-hint">
                        您可以 <a class="copy-link" @click.prevent="copyLink(authProgressData.link_url)">复制链接</a> 发送给法定代表人/负责人
                    </p>
                </div>
                <div class="progress-btn-wrap">
                    <Button 
                        type="primary" 
                        size="large"
                        ghost
                        class="progress-btn"
                        style="color: #fff;"
                        @click="viewAuthProgress"
                    >
                        查看授权进度
                    </Button>
                </div> 
            </div>
            <div slot="footer"></div>
        </Modal>

        <!-- 弹窗5：提示弹窗（法人认证尚未认证） -->
        <Modal
            v-model="showTipModal"
            :mask-closable="false"
            title="提示"
            width="400"
            class-name="tip-modal"
            @on-cancel="closeTipModal"
            :footer-hide="true"
        >
            <div class="tip-modal-content">
                <p class="tip-message">法人认证尚未认证,请等待!!!</p>
            </div>
            <div slot="footer">
                <!-- class="modal-footer-custom" -->
                <!-- <Button 
                    type="primary"  
                    @click="viewAuthProgressFromTip" 
                    class="confirm-btn"
                    size="small"
                >
                    查看授权进度
                </Button> -->
            </div>
        </Modal>

        <!-- 个人认证弹窗 -->
        <PersonalCertification v-model="showPersonalCertModal" @success="handlePersonalCertSuccess" />
    </div>
</template>

<script>
import { getEnterpriseVerifiedInfo, addEnterpriseVerified, signAuthBook, getAgreement, checkEnterprise } from '@/api/interFace'
import config from '@/config/index'
import { getCookies } from '@/utils/helper'
import PersonalCertification from './PersonalCertification'

export default {
    name: 'NotCertified',
    props: {
        // 场景：upgrade=原逻辑（从 NotCertified 进入企业认证）
        // newEnterprise=从“认证新企业”进入（来自 BasicInfoContent，不应重复调部分接口）
        certScene: {
            type: String,
            default: 'upgrade'
        }
    },
    components: {
        PersonalCertification
    },
    data() {
        return {
            userInfo: {
                name: '',
                phone: ''
            },
            newEnterpriseCertType: 'add',
            // 弹窗状态
            showAuthFormModal: false,      // 弹窗1：认证授权表单
            showOrgCertifyModal: false,    // 弹窗2：组织机构认证
            showImageModal: false,         // 弹窗3：图片查看
            showAuthProgressModal: false,  // 弹窗4：授权进度
            showTipModal: false,           // 弹窗5：提示
            showAgreementModal: false,     // 协议图片弹窗
            showPersonalCertModal: false,  // 个人认证弹窗
            isPersonalCertified: false,    // 个人是否认证
            subEnterpriseInfo:{},
            // 营业执照开关：默认不展示（需要时改为 true）
            showLicense: true,
            // 上传配置（复用全局 common/uploads）
            imageAction: config.apiUrl + '/adminapi/common/uploads',
            // 营业执照 OCR 上传接口
            licenseOcrAction: config.apiUrl + '/adminapi/company/upload_identify_license',
            // 营业执照示例图（src/assets/imgs/licenseExample.png）
            licenseExampleUrl: require('@/assets/imgs/licenseExample.png'),
            showLicenseExampleModal: false,
            headers: { 'Authori-zation': getCookies('token') },
            // 表单数据
            formData: {
                orgType: 'enterprise',      // 组织类型：enterprise-企业, individual-个体工商户
                authMethod: 'legal',        // 认证方式：legal-法定代表人
                license: '',                // 营业执照（前端预览 URL：blob/base64）
                license_server_path: '',    // 营业执照（后端返回的 file_path/src，用于提交）
                orgName: '',                // 组织机构名称
                creditCode: '',             // 统一社会信用代码
                legalPerson: '',            // 法定代表人
                legalIdCard: '',            // 法人身份证号
                authScope: '速速云签平台',   // 授权范围
                authPeriod: 'longterm',     // 授权期限：longterm-长期有效, nonlongterm-非长期有效
                authEndDate: '',            // 授权结束日期（非长期有效时必填）
                // 认证授权 + 打款验证（按图补充，不影响现有提交流程）
                authBook: '',               // 授权书上传结果（图片 URL）
                payVerifyWay: 'me_pay_to_company', // 打款验证方式
                payAccountName: '',         // 我司向xxx打款：账户名称（我方）
                payOpenBank: '',            // 我司向xxx打款：开户银行（我方）
                payBankNo: '',              // 我司向xxx打款：银行账号（我方）
                agreed: false               // 是否同意协议
            },
            // OCR 回填后锁定组织名称（置灰不可编辑）
            orgNameLocked: false,
            // OCR 上传识别中动效
            licenseOcrLoading: false,
            // 本地预览 objectURL（用于释放）
            licenseObjectUrl: '',
            // 日期选择器选项
            datePickerOptions: {
                disabledDate(date) {
                    // 不能选择今天之前的日期
                    return date && date.valueOf() < Date.now() - 86400000
                }
            },
            // 表单验证规则
            formRules: {
                license: [
                    {
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            if (this.showLicense && !this.formData.license) {
                                callback(new Error('请上传营业执照'))
                            } else {
                                callback()
                            }
                        }
                    }
                ],
                orgName: [
                    { required: true, message: '请输入组织机构名称', trigger: 'blur' }
                ],
                creditCode: [
                    { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
                    { pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/, message: '统一社会信用代码格式不正确', trigger: 'blur' }
                ],
                legalPerson: [
                    { required: true, message: '请输入法定代表人', trigger: 'blur' }
                ],
                legalIdCard: [
                    { required: true, message: '请输入法人身份证号', trigger: 'blur' }
                ],
                authScope: [
                    { required: true, message: '授权范围不能为空', trigger: 'blur' }
                ],
                authPeriod: [
                    { required: true, message: '请选择授权期限', trigger: 'change' }
                ],
                authEndDate: [
                    { 
                        required: true, 
                        message: '请选择授权结束日期', 
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            if (this.formData.authPeriod === 'nonlongterm' && !value) {
                                callback(new Error('请选择授权结束日期'))
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            },
            // 组织机构认证数据
            orgCertifyData: {
                orgName: ''
            },
            orgCertifyRules: {
                orgName: [
                    { required: true, message: '请输入单位名称', trigger: 'blur' }
                ]
            },
            // 授权书图片/组件（800*1132）
            imageList: [],                // 授权书图片（enterprise_info.authbook_path，弹窗3用）
            assemblyArr: [],              // 授权书组件定位数据（enterprise_info.assembly_arr）
            agreementImageList: [],       // 协议图片（新弹窗用）
            // 授权进度数据
            authProgressData: {},
            // 授权链接
            authLink: '',
            // 认证状态
            authStatusData: null,
            enterpriseAuthId: '', // 企业认证信息ID（用于提交/签署）
            // 企业存在性检查（用于 blur 提示 & 拦截下一步）
            existCheck: {
                orgName: { isExist: false, msg: '' },
                creditCode: { isExist: false, msg: '' }
            },
            existCheckKey: {
                orgName: '',
                creditCode: ''
            },
            existCheckLoading: false,
            existCheckDebounceTimer: null
        }
    },
    computed: {

        payInfo() {
            // 后端若有返回收款信息，这里可直接取（当前文件未体现接口字段，先做安全兜底）
            const info = (this.authStatusData && this.authStatusData.enterprise_info) || {}
            const pay = info.pay_info || info.payInfo || {}
            return {
                accountName: pay.account_name || 'xxxx有限公司',
                openBank: pay.open_bank || 'xxxx支行',
                bankNo: pay.bank_no || '6666666666666',
                unionBankNo: pay.union_bank_no || '666666666666666666',
                downloadName: pay.download_name || 'xxx收款信息(加盖公章)',
                remark: pay.remark || 'xxxxxx',
                amount: pay.amount || '0.01'
            }
        },
        canGoNext() {
            const basicValid = this.formData.orgName && 
                               this.formData.creditCode && 
                               this.formData.legalPerson && 
                               this.formData.authPeriod && 
                               this.formData.agreed
            
            // 如果选择非长期有效，需要填写授权结束日期
            if (this.formData.authPeriod === 'nonlongterm') {
                return basicValid && this.formData.authEndDate
            }
            
            return basicValid
        }
    },
    created() {
        this.getUserInfo()
        // 新企业认证场景：不再拉取“个人认证状态”接口，避免与原逻辑重复/干扰
        if (this.certScene !== 'newEnterprise') {
            this.getPersonalCertified()
        } else {
            this.isPersonalCertified = true
        }
    },
    methods: {
        changeNewEnterpriseCertType(type) { 
            this.newEnterpriseCertType = type
        },
        clearExistCheck(field) {
            if (field === 'orgName' || field === 'creditCode') {
                this.existCheck[field] = { isExist: false, msg: '' }
                this.existCheckKey[field] = ''
            } else {
                this.existCheck = {
                    orgName: { isExist: false, msg: '' },
                    creditCode: { isExist: false, msg: '' }
                }
                this.existCheckKey = { orgName: '', creditCode: '' }
            }
        },
        async runExistCheck(field, rawValue) {
            const value = (rawValue || '').trim()
            if (!value) {
                this.clearExistCheck(field)
                return { isExist: false, msg: '' }
            }
            if (field !== 'orgName' && field !== 'creditCode') return { isExist: false, msg: '' }
            // 接口约定：type=1 企业名称，type=2 信用代码
            const type = field === 'orgName' ? 1 : 2
            const key = `${type}::${value}`
            if (this.existCheckLoading) return null
            if (this.existCheckKey[field] === key) return this.existCheck[field]

            this.existCheckLoading = true
            try {
                const res = await checkEnterprise({ type, name: value })
                const payload = (res && res.data) || {}
                const isExist = !!payload.is_exist
                const msg = payload.msg || ''
                this.existCheck[field] = { isExist, msg }
                this.existCheckKey[field] = key
                return this.existCheck[field]
            } catch (err) {
                this.clearExistCheck(field)
                this.$Message.error(err.msg || '企业检查失败')
                return { isExist: false, msg: '' }
            } finally {
                this.existCheckLoading = false
            }
        },
        handleOrgNameBlur(val) {
            // 不在 blur 上 await，避免用户点击“下一步”被阻塞产生卡顿感
            this.runExistCheck('orgName', val)
        },
        async handleCreditCodeBlur() {
            await this.runExistCheck('creditCode', this.formData.creditCode)
        },
        onAuthPeriodChange(val) {
            if (val === 'longterm') {
                this.formData.authEndDate = ''
            }
        },
        // 授权结束日期选择（统一为 YYYY-MM-DD 字符串）
        handleAuthEndDateChange(value) {
            // iView 的 DatePicker on-change 直接返回格式化后的字符串
            this.formData.authEndDate = value || ''
        },
        getUserInfo() {
            // TODO: 获取用户信息
            // 模拟数据
            const userInfo = this.$store.state.userInfo || {}
            this.userInfo = {
                name: userInfo.name || '名称',
                phone: userInfo.phone || '12345678912'
            }
        },
        formatPhone(phone) {
            if (!phone) return ''
            if (phone.length === 11) {
                return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
            }
            return phone
        },
        // 获取个人是否认证
        async getPersonalCertified() {
            try {
                const res = await getEnterpriseVerifiedInfo({ enterprise_auth_id: this.enterpriseAuthId || '' })
                const data = (res && res.data) || {}
                // 从接口返回的数据中获取 operator_id_card
                const is_person_auth = data.is_person_auth || ''
                
                if(!is_person_auth){
                    this.isPersonalCertified = true
                    // 更新用户信息
                    if (data.real_name) {
                        this.userInfo.name = data.real_name
                    }
                    if (data.phone) {
                        this.userInfo.phone = data.phone
                    }
                } else {
                    this.isPersonalCertified = false
                }
            } catch (err) {
                console.error('获取个人认证状态失败:', err)
                this.isPersonalCertified = false
            }
        },
        // 点击企业认证按钮
        goToCertify() {
            this.fetchVerifiedInfoAndRoute()
        },
        // 打开个人认证弹窗
        goToPerson(){
            this.showPersonalCertModal = true
        },
        // 个人认证成功回调
        handlePersonalCertSuccess() {
            // 重新获取个人认证状态 
            setTimeout(() => { 
                // window.location.reload();  //清除缓存刷新页面
                location.reload();
            }, 500) 
        },
        async fetchVerifiedInfoAndRoute() {
            try {
                const res = await getEnterpriseVerifiedInfo({ enterprise_auth_id: this.enterpriseAuthId || '' })
                const data = (res && res.data) || {}
                this.authStatusData = data 
                const enterpriseInfo = data.enterprise_info || {}
                const userVerified = data.user_verified || [] 
                // upgrade 场景：已满足用户验证条件时直接收口
                // newEnterprise 场景：仍需走“组织机构认证”流程，不应提前 return
                if (userVerified && userVerified.id_card && this.certScene !== 'newEnterprise') {
                    this.$emit('refresh')
                    return
                }
                
                const hasSubmitted = enterpriseInfo && typeof enterpriseInfo === 'object' && Object.keys(enterpriseInfo).length > 0
                if (!hasSubmitted) {
                    this.showOrgCertifyModal = true
                    return
                }

                // 回显表单 & 授权链接
                this.formData.orgName = enterpriseInfo.prise_name || ''
                this.orgCertifyData.orgName = enterpriseInfo.prise_name || ''
                this.formData.creditCode = enterpriseInfo.credit_code || ''
                this.formData.legalPerson = enterpriseInfo.real_name || ''
                this.formData.authEndDate = enterpriseInfo.auth_deadline || ''
                this.formData.authPeriod = enterpriseInfo.is_auth_limit === 1 ? 'nonlongterm' : 'longterm'
                this.subEnterpriseInfo = enterpriseInfo
                this.authLink = enterpriseInfo.link_url || ''

                // 授权书图片 & 组件配置
                this.imageList = Array.isArray(enterpriseInfo.authbook_path) ? enterpriseInfo.authbook_path : []
                this.assemblyArr = Array.isArray(enterpriseInfo.assembly_arr) ? enterpriseInfo.assembly_arr : [] 

                // 企业认证信息ID
                this.enterpriseAuthId = enterpriseInfo.id || ''
                
                // this.enterpriseAuthId = data.id || ''

                // 提交后判断：身份证一致→弹窗3，否则→弹窗4
                const currentIdCard = data.operator_id_card || ''
                const enterpriseIdCard = enterpriseInfo.id_card || ''
                if (currentIdCard && enterpriseIdCard && currentIdCard === enterpriseIdCard) {
                    await this.loadImageList()
                    this.showImageModal = true
                } else {
                    this.loadAuthProgressData()
                    this.showAuthProgressModal = true
                }
            } catch (err) {
                this.$Message.error(err.msg || '获取认证信息失败')
                this.showAuthFormModal = true
            }
        },
        handleBack() {
            this.$emit('back')
        },
        // 关闭认证授权表单弹窗
        closeAuthFormModal() {
            this.showAuthFormModal = false
            this.resetFormData()
            this.clearExistCheck()
        },
        // 下一步：从弹窗2（组织机构认证）跳转到弹窗1（组织机构认证授权表单）
        nextToStep2() {
            this.$refs.orgCertifyForm.validate(async (valid) => {
                if (!valid) return
                // 点击“下一步”时兜底确保校验完成（避免只触发了防抖还没跑完）
                const name = (this.orgCertifyData.orgName || '').trim()
                if (name && !this.existCheckLoading) {
                    await this.runExistCheck('orgName', name)
                }
                if (this.existCheck.orgName.isExist) {
                    this.$Message.warning(this.existCheck.orgName.msg || '平台中存在已认证的同名组织机构')
                    return
                }
                // 关闭弹窗2，打开弹窗1
                this.showOrgCertifyModal = false
                // 将组织机构名称传递给弹窗1
                this.formData.orgName = this.orgCertifyData.orgName
                this.showAuthFormModal = true
            })
        },

        scheduleExistCheck(field, rawValue) {
            if (field !== 'orgName') return
            if (this.existCheckDebounceTimer) clearTimeout(this.existCheckDebounceTimer)
            this.existCheckDebounceTimer = setTimeout(() => {
                this.runExistCheck(field, rawValue)
            }, 300)
        },

        onOrgNameInputChange() {
            this.clearExistCheck('orgName')
            this.scheduleExistCheck('orgName', this.orgCertifyData.orgName)
        },
        // 上一步：从弹窗1（组织机构认证授权表单）回到弹窗2（组织机构认证）
        prevToStep1() {
            // 关闭弹窗1，打开弹窗2
            this.showAuthFormModal = false
            this.showOrgCertifyModal = true
        },
        // 关闭组织机构认证弹窗
        closeOrgCertifyModal() {
            this.showOrgCertifyModal = false
            this.orgCertifyData.orgName = ''
            this.clearExistCheck()
        },
        // 下一步：从弹窗1（组织机构认证授权表单）跳转到弹窗3（图片查看）
        nextToStep3() {
            this.$refs.authForm.validate((valid) => {
                if (valid) {
                    this.$refs.authForm2.validate((valid2) => {
                        if (valid2) {
                            if (this.existCheck.orgName.isExist || this.existCheck.creditCode.isExist) {
                                this.$Message.warning(
                                    this.existCheck.orgName.msg ||
                                    this.existCheck.creditCode.msg ||
                                    '平台中存在已认证的同名组织机构'
                                )
                                return
                            }
                            this.submitEnterpriseVerified()
                        }
                    })
                }
            })
        },
        async submitEnterpriseVerified() {
            try {
                const storeUser = this.$store.state.userInfo || {}
                const statusData = this.authStatusData || {}
                const payload = {
                    // 公众号/应用 ID 仍从用户信息中取
                    uniacid_id: storeUser.uniacid_id || '',
                    // 经办人手机号：来自 getEnterpriseVerifiedInfo 顶层的 phone
                    phone: statusData.phone || storeUser.phone || this.userInfo.phone,
                    // 经办人姓名：来自 getEnterpriseVerifiedInfo 顶层的 real_name
                    operator_name: statusData.real_name || storeUser.name || this.userInfo.name,
                    // 法人姓名
                    real_name: this.formData.legalPerson,
                    // 组织名称
                    prise_name: this.formData.orgName,
                    // 统一社会信用代码
                    credit_code: this.formData.creditCode,
                    // 组织类型：1 企业，2 个体工商户
                    type: this.formData.orgType === 'enterprise' ? 1 : 2,
                    auth_type: 1,
                    // 授权期限与是否长期
                    auth_deadline: this.formData.authPeriod === 'longterm' ? '' : this.formData.authEndDate,
                    is_auth_limit: this.formData.authPeriod === 'longterm' ? 0 : 1,
                    // 经办人身份证号：来自 getEnterpriseVerifiedInfo 顶层的 operator_id_card
                    operator_id_card: statusData.operator_id_card || '',
                    // 法人身份证号
                    id_card: this.formData.legalIdCard || '',
                    // 企业认证信息 ID
                    enterprise_auth_id: this.enterpriseAuthId || '',
                    // 营业执照
                    business_license: this.formData.license_server_path || ''
                }
                const submitRes = await addEnterpriseVerified(payload)
                const verifiedId = (((submitRes || {}).data || {}).verified_id) || ''
                // 认证新企业场景下，后续查询进度需使用新返回的 verified_id
                if (verifiedId) {
                    this.enterpriseAuthId = verifiedId
                }
                this.$Message.success('提交成功')
                setTimeout(() => {
                    this.$Message.success('提交成功，请等待审核，也可去认证列表中查看审核进度')
                }, 1500)

                this.showAuthFormModal = false
                await this.fetchVerifiedInfoAndRoute()
            } catch (err) {
                this.$Message.error(err.msg || '提交失败')
            }
        },
        onLicenseUploadSuccess(e) {
            this.licenseOcrLoading = false
            const payload = (e && e.data) || {}
            const filePath = payload.file_path || payload.src || ''
            // 后端不一定提供可访问 URL，这里只保存用于提交的相对路径/标识
            this.formData.license_server_path = filePath || ''

            // 自动回填 OCR 识别结果
            if (payload.company_name) {
                this.formData.orgName = payload.company_name
                this.orgNameLocked = true
            }
            if (payload.credit_code) {
                this.formData.creditCode = payload.credit_code
            }
            if (payload.legal_person) {
                this.formData.legalPerson = payload.legal_person
            }

            this.$Message.success((e && e.msg) || '上传并识别成功')

            // OCR 回填后，自动进行企业名称/信用代码存在性检测
            if (payload.company_name) {
                this.runExistCheck('orgName', payload.company_name).then((r) => {
                    if (r && r.isExist) {
                        this.$Message.warning(r.msg || '平台中存在已认证的同名组织机构')
                    }
                })
            }
            if (payload.credit_code) {
                this.runExistCheck('creditCode', payload.credit_code)
            }

            // 触发表单校验（仅 showLicense=true 时有效）
            this.$nextTick(() => {
                if (this.$refs.authForm && this.$refs.authForm.validateField) {
                    this.$refs.authForm.validateField('license')
                    this.$refs.authForm.validateField('orgName')
                    this.$refs.authForm.validateField('creditCode')
                    this.$refs.authForm.validateField('legalPerson')
                }
            })
        },
        onLicenseFormatError() {
            this.licenseOcrLoading = false
            this.$Message.warning('仅支持上传 jpg/png 图片')
        },
        beforeLicenseOcrUpload(file) {
            this.licenseOcrLoading = true
            // 本地预览：即使后端不返回全路径也可展示
            try {
                if (this.licenseObjectUrl) URL.revokeObjectURL(this.licenseObjectUrl)
                const objectUrl = URL.createObjectURL(file)
                this.licenseObjectUrl = objectUrl
                this.formData.license = objectUrl
            } catch (err) {
                // ignore
            }
            // 每次重新上传前清空后端路径，避免误提交旧值
            this.formData.license_server_path = ''
            return true
        },
        onLicenseOcrError() {
            this.licenseOcrLoading = false
            this.$Message.error('上传失败，请重试')
        },
        openLicenseExample() {
            if (!this.licenseExampleUrl) {
                this.$Message.info('暂无示例图片')
                return
            }
            this.showLicenseExampleModal = true
        },
        previewLicense() {
            if (!this.formData.license) return
            window.open(this.formData.license)
        },
        removeLicense() {
            this.formData.license = ''
            this.formData.license_server_path = ''
            // 删除营业执照时清空 OCR 回填数据 & 解除锁定
            this.formData.orgName = ''
            this.formData.creditCode = ''
            this.formData.legalPerson = ''
            this.orgNameLocked = false
            this.licenseOcrLoading = false
            try {
                if (this.licenseObjectUrl) URL.revokeObjectURL(this.licenseObjectUrl)
            } catch (err) {
                // ignore
            }
            this.licenseObjectUrl = ''
            this.clearExistCheck()
            this.$nextTick(() => {
                if (this.$refs.authForm && this.$refs.authForm.validateField) {
                    this.$refs.authForm.validateField('license')
                    this.$refs.authForm.validateField('orgName')
                    this.$refs.authForm.validateField('creditCode')
                    this.$refs.authForm.validateField('legalPerson')
                }
            })
        },
        normalizeOcrFileUrl(filePath) {
            const raw = (filePath || '').trim()
            if (!raw) return ''
            if (/^https?:\/\//.test(raw)) return raw
            try {
                const origin = new URL(this.licenseOcrAction).origin
                const normalizedPath = raw.replace(/^\/+/, '')
                return `${origin}/${normalizedPath}`
            } catch (err) {
                // 兜底：仍使用原值，避免直接报错
                return raw
            }
        },
        // 授权书上传/预览/删除（按图补充）
        onAuthBookUploadSuccess(e) {
            this.formData.authBook = (e && e.data && e.data.src) ? e.data.src : ''
            this.$Message.success('上传成功')
        },
        onAuthBookFormatError() {
            this.$Message.warning('仅支持上传 jpg/png 图片')
        },
        previewAuthBook() {
            if (!this.formData.authBook) return
            window.open(this.formData.authBook)
        },
        removeAuthBook() {
            this.formData.authBook = ''
        },
        downloadAuthBookTemplate() {
            // 项目内未找到授权书模板静态文件或对应下载接口，先给出友好提示，避免点击无响应
            this.$Message.info('暂无可用的授权书下载链接，请联系管理员配置模板')
        },
        downloadPayInfoFile() {
            // 若后端提供下载链接，可在 payInfo 中补充 url 后直接 window.open
            this.$Message.info('暂无可下载文件')
        },
        // 上一步：从弹窗3（图片查看）回到弹窗1（组织机构认证授权表单）
        prevToStep2() {
            // 关闭弹窗3，打开弹窗1
            this.showImageModal = false
            this.showAuthFormModal = true
        },
        // 加载授权书图片列表（直接使用 enterprise_info 中的数据）
        async loadImageList() {
            const info = (this.authStatusData && this.authStatusData.enterprise_info) || {}
            this.imageList = Array.isArray(info.authbook_path) ? info.authbook_path : []
            this.assemblyArr = Array.isArray(info.assembly_arr) ? info.assembly_arr : []
        },
        // 图片加载错误处理
        handleImageError(e) {
            //e.target.src = require('@/assets/imgs/default-image.png')
        },
        // 关闭图片查看弹窗
        closeImageModal() {
            this.showImageModal = false
        },
        // 根据页码获取对应的组件数组
        getAssemblyByPage(page) {
            if (!Array.isArray(this.assemblyArr)) return []
            return this.assemblyArr.filter(item => Number(item.page) === Number(page))
        },
        // 计算组件在图片上的样式（以 px 为单位定位）
        getAssemblyStyle(field) {
            const style = {
                position: 'absolute',
                left: ((field.position_x || 0) + 20) + 'px',
                top: ((field.position_y || 0) + 20) + 'px',
                fontSize: (field.font_size || 14) + 'px',
                lineHeight: '1.2',
                color: '#333'
            }
            // 如有宽高则一起设置，防止超出
            // if (field.width) {
            //     style.width = field.width + 'px'
            // }
            if (field.height) {
                style.height = field.height + 'px'
            }
            return style
        },
        // 提交认证（图3完成后）
        submitAuth() {
            const userInfo = this.$store.state.userInfo || {}
            const info = (this.authStatusData && this.authStatusData.enterprise_info) || {}
            const payload = {
                // uniacid_id: userInfo.uniacid_id || '',
                // real_name: info.real_name || this.formData.legalPerson,
                // phone: info.phone || '',
                // id_card: info.id_card || '',
                // prise_name: info.prise_name || this.formData.orgName,
                // credit_code: info.credit_code || this.formData.creditCode,
                // type: this.formData.orgType === 'enterprise' ? 1 : 2,
                // auth_type: 1,
                // operator_name: info.operator_name || userInfo.name || this.userInfo.name,
                // auth_deadline: info.auth_deadline || '',
                // is_auth_limit: info.is_auth_limit || 0,
                // operator_id_card: info.operator_id_card || '',
                enterprise_auth_id: this.subEnterpriseInfo.id || ''
            }  
            signAuthBook(payload).then(res => {
                this.$Message.success(res.msg || '签署成功')
                this.showImageModal = false
                if (this.certScene == 'newEnterprise') {
                    this.$emit('refresh')
                    return
                }
                this.fetchVerifiedInfoAndRoute()
                // this.loadAuthProgressData()
                // this.showAuthProgressModal = true
            }).catch(err => {
                this.$Message.error(err.msg || '签署失败')
            })
        },
        // 加载授权进度数据
        loadAuthProgressData() { 
            getEnterpriseVerifiedInfo({ enterprise_auth_id: this.enterpriseAuthId || '' }).then(res => {
                const data = (res && res.data) || {}
                this.authProgressData = data.enterprise_info || {}
            }).catch(err => {
                this.$Message.error(err.msg || '获取授权进度数据失败')
            })
        },
        // 获取授权期限文本
        getAuthPeriodText(value, endDate) {
            if (value === 'longterm') {
                return '长期有效'
            } else if (value === 'nonlongterm' && endDate) {
                // 格式化日期显示
                const date = new Date(endDate)
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                return `${year}-${month}-${day}`
            }
            return '非长期有效'
        },
        // 复制链接
        copyLink(linkUrl) {
            // TODO: 实现复制链接功能
            const input = document.createElement('input')
            input.value = linkUrl
            document.body.appendChild(input)
            input.select()
            document.execCommand('copy')
            document.body.removeChild(input)
            this.$Message.success('链接已复制')
        },
        // 查看授权进度
        async viewAuthProgress() {
            try {
                const res = await getEnterpriseVerifiedInfo({ enterprise_auth_id: this.enterpriseAuthId || '' })
                const data = (res && res.data) || {}
                const userVerified = data.user_verified || []

                if (!userVerified || userVerified.length === 0) {
                    // 未授权 → 提示弹窗（弹窗5）
                    this.showTipModal = true
                } else {
                    // 已授权 → 回到企业基本信息页
                    this.closeAuthProgressModal()
                    this.$emit('refresh')
                }
            } catch (err) {
                this.$Message.error(err.msg || '获取授权进度失败')
            }
        },
        // 关闭授权进度弹窗
        closeAuthProgressModal() {
            this.showAuthProgressModal = false
        },
        // 从提示弹窗查看授权进度
        viewAuthProgressFromTip() {
            this.showTipModal = false
            this.loadAuthProgressData()
            this.showAuthProgressModal = true
        },
        // 关闭提示弹窗
        closeTipModal() {
            this.showTipModal = false
        },
        // 显示隐私政策
        showPrivacyPolicy() {
            this.openAgreementByType(2)
        },
        // 显示数字证书使用协议
        showCertificateAgreement() {
            this.openAgreementByType(3)
        },
        async openAgreementByType(type) {
            try {
                const res = await getAgreement({ type })
                const list = (res && res.code === 200 && Array.isArray(res.data)) ? res.data : []
                const item = list.find(it => Number(it.type) === Number(type))
                const urls = (item && item.contract_imgs_url) || []
                if (urls.length === 0) {
                    this.$Message.warning('暂未配置协议内容')
                    return
                }
                // 使用单独的协议弹窗展示全部协议图片
                this.agreementImageList = urls
                this.showAgreementModal = true
            } catch (err) {
                this.$Message.error('获取协议内容失败')
            }
        },
        // 关闭协议弹窗
        closeAgreementModal() {
            this.showAgreementModal = false
            this.agreementImageList = []
        },
        // 重置表单数据
        resetFormData() {
            this.formData = {
                orgType: 'enterprise',
                authMethod: 'legal',
                orgName: '',
                creditCode: '',
                legalPerson: '',
                authScope: '速速云签平台',
                authPeriod: 'longterm',
                authEndDate: '',
                agreed: false
            }
            this.orgCertifyData = {
                orgName: ''
            }
            this.clearExistCheck()
        }
    }
}
</script>

<style scoped lang="scss">
.not-certified-wrap {
    width: 100%;
    min-height: calc(100vh - 150px);
    background: #fff;
    padding: 40px 20px;
}

/* 认证新企业：不要强行撑高，避免内容高度过大 */
.not-certified-wrap.scene-new-enterprise {
    min-height: 600px;
    padding: 24px 20px;
}

/* 营业执照上传（默认 showLicense=false，不影响现有页面） */
.license-upload-wrap {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}
.license-left {
    display: flex;
    flex-direction: column;
    position: relative;
}
.license-right {
    padding-top: 6px;
    min-width: 220px;
}
.license-example {
    display: inline-block;
    color: #2d8cf0;
    font-size: 12px;
    margin-bottom: 8px;
}
.license-desc {
    font-size: 12px;
    color: #999;
    line-height: 1.6;
}
.license-uploader {
    width: 160px;
    height: 110px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.license-uploader .plus {
    font-size: 32px;
    color: #c0c4cc;
    line-height: 32px;
}
.license-uploader .tips {
    margin-top: 6px;
    font-size: 12px;
    color: #999;
}
.license-preview {
    display: flex;
    align-items: center;
}
.license-img {
    width: 160px;
    height: 110px;
    border-radius: 6px;
    object-fit: cover;
    border: 1px solid #eee;
}
.license-actions {
    margin-left: 12px;
}
.license-remind {
    margin-top: 8px;
    padding: 0 10px;
    background: #fff7e6;
    border: 1px solid #ffd591;
    border-radius: 6px;
    font-size: 12px;
    color: #ad4e00;
    width: fit-content;
}

/* 组织名称锁定后置灰 */
::v-deep .locked-input {
    .ivu-input {
        background: #f5f5f5 !important;
        color: #999 !important;
        cursor: not-allowed;
    }
}

/* OCR 识别中动效遮罩 */
.license-ocr-loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 160px;
    height: 110px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid #eee;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
}
.license-ocr-loading .txt {
    margin-top: 6px;
    font-size: 12px;
    color: #666;
}
.license-ocr-loading .dots {
    display: flex;
    gap: 6px;
}
.license-ocr-loading .dots span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #4877E8;
    opacity: 0.3;
    animation: licenseDots 0.9s infinite ease-in-out;
}
.license-ocr-loading .dots span:nth-child(2) {
    animation-delay: 0.15s;
}
.license-ocr-loading .dots span:nth-child(3) {
    animation-delay: 0.3s;
}
@keyframes licenseDots {
    0%, 100% { opacity: 0.3; transform: translateY(0); }
    50% { opacity: 1; transform: translateY(-4px); }
}

/* 上传授权书 + 打款验证（按图补充） */
.auth-pay-section {
    .download-link {
        margin-left: 12px;
        font-size: 12px;
        color: #2d8cf0;
    }
}
.authbook-upload-row {
    display: flex;
    align-items: center;
    gap: 18px;
    margin-left: 60px; // 与表单 label 对齐，整体右缩进一点
}
.authbook-uploader {
    width: 240px;
    height: 120px;
    border: 1px solid #e9eaec;
    border-radius: 8px;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .plus {
        font-size: 44px;
        line-height: 44px;
        color: #c0c4cc;
    }
}
.authbook-preview {
    display: flex;
    align-items: center;
}
.authbook-img {
    width: 240px;
    height: 120px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid #eee;
}
.authbook-actions {
    margin-left: 12px;
}
.authbook-tip {
    font-size: 12px;
    color: #999;
}
.pay-verify-wrap {
    margin-top: 8px;
    margin-left: 0; // 打款验证区域整体右缩进
}
.pay-verify-radio {
    margin-bottom: 8px;
}
.pay-verify-desc {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
    .pay-verify-note {
        color: #c5c8ce;
    }
}
.pay-info-card {
    width: 520px;
    border: 1px solid #e9eaec;
    border-radius: 8px;
    padding: 16px 18px;
    margin-left: 60px;
    background: #fff;
}
.pay-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 22px;
    margin: 4px 0;
    .k {
        color: #999;
    }
    .v {
        color: #17233d;
    }
    &.amount {
        margin-top: 10px;
        .v {
            font-size: 18px;
            font-weight: 600;
        }
    }
}

.exist-tip {
    margin-top: -20px;
    color: #ed4014;
    font-size: 12px;
    line-height: 1.4;
}

.not-certified-content {
    max-width: 1200px;
    margin: 0 auto;
}

.page-title {
    position: relative;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #17233d;
    margin-bottom: 60px;
    padding: 0 80px;
}

.back-btn {
    position: absolute;
    left: auto;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    font-weight: 500;
}
.back-icon {
    font-size: 18px;
    margin-top: -1px;
    color: inherit;
}

.new-enterprise-title {
    display: inline-block;
}

.upgrade-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
}

.user-panel {
    flex: 1;
    min-width: 300px;
    max-width: 400px;
    background: #F1F5FB;
    border-radius: 8px;
    padding: 40px 30px;
    text-align: center;

    .panel-header {
        font-size: 18px;
        font-weight: bold;
        color: #17233d;
        margin-bottom: 30px;
    }

    .user-icon {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        background: #4877E8;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 24px;

        .icon-text {
            font-size: 32px;
            font-weight: bold;
            color: #fff;
        }
    }

    .user-name {
        font-size: 16px;
        color: #17233d;
        margin-bottom: 12px;
    }

    .user-phone {
        font-size: 14px;
        color: #808695;
    }

    .certify-btn {
        margin-top: 30px;
        min-width: 160px;
        height: 44px;
        font-size: 16px;
    }
}

.upgrade-arrow-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 150px;

    .arrow-icon {
        font-size: 48px;
        color: #4877E8;
        margin-bottom: 16px;
    }

    .upgrade-text {
        font-size: 16px;
        color: #4877E8;
        font-weight: 500;
    }
}

// 弹窗通用样式
.modal-footer-custom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    padding: 12px 24px; 
    background: #fff; 

    .cancel-btn {
        min-width: 84px;
        height: 32px;
        background: #fff;
        border: 1px solid #dcdee2;
        color: #515a6e;
        font-size: 13px;

        &:hover {
            border-color: #4877E8;
            color: #4877E8;
        }
    }

    .prev-btn {
        min-width: 84px;
        height: 32px;
        background: #fff;
        border: 1px solid #dcdee2;
        color: #515a6e;
        font-size: 13px;

        &:hover {
            border-color: #4877E8;
            color: #4877E8;
        }
    }

    .confirm-btn {
        min-width: 84px;
        height: 32px;
        background: #4877E8;
        border-color: #4877E8;
        font-size: 13px;

        &:hover {
            background: #3d6bd8;
            border-color: #3d6bd8;
        }

        &:disabled {
            background: #c5c8ce;
            border-color: #c5c8ce;
            color: #fff;
            cursor: not-allowed;
            opacity: 0.6;
        }
    }
}

// 弹窗1：认证授权表单
.auth-form-content {
    padding: 14px 18px 12px;

    .form-section {
        margin-bottom: 16px;

        .section-title {
            font-size: 14px;
            font-weight: bold;
            color: #17233d;
            margin-bottom: 16px;
        }

        .option-group {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
            padding-left: 36px;

            .option-item {
                min-width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border: 1px solid #dcdee2;
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.2s;
                color: #515a6e;

                &:hover {
                    border-color: #4877E8;
                    color: #4877E8;
                }

                &.active {
                    border-color: #4877E8;
                    background: #4877E8;
                    color: #fff;
                }
            }
        }

        .auth-period-select {
            width: 240px;
            max-width: 100%;
        }
    }

    .agreement-section {
        margin-top: 24px;
        padding-top: 24px; 

        a {
            color: #4877E8;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

// 弹窗2：组织机构认证
.org-certify-content {
    padding: 18px 24px 22px;

    .org-certify-desc {
        font-size: 14px;
        color: #515a6e;
        line-height: 1.8;
        margin: 0 0 16px;
    }

    .org-certify-box {
        background: #F2F2F2;
        border-radius: 4px;
        padding: 28px 24px 26px;
        text-align: center;
    }

    .org-certify-box-title {
        font-size: 14px;
        color: #515a6e;
        line-height: 1.8;
        margin-bottom: 18px;
    }

    ::v-deep .ivu-form-item {
        margin-bottom: 0;
    }

    ::v-deep .ivu-input-wrapper {
        max-width: 520px;
        margin: 0 auto;

        .ivu-input {
            height: 40px;
            font-size: 14px;
            border-radius: 4px;
        }
    }
}

// 弹窗3：图片查看
.image-view-content {
    padding: 24px;
    max-height: 600px;
    overflow-y: auto;

    .image-list {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .image-item {
            width: 100%;
            text-align: center;

            .image-page-wrapper {
                position: relative;
                width: 800px;
                margin: 0 auto;

                img {
                    max-width: 800px;
                    max-height: 1132px;
                    width: 100%;
                    height: auto;
                    border: 1px solid #e8eaec;
                    border-radius: 4px;
                }

                .assembly-field {
                    position: absolute;
                    word-break: break-all;
                    color: #333;
                }
            }
        }
    }

    .empty-image {
        text-align: center;
        padding: 60px 0;
        color: #808695;

        p {
            margin-top: 16px;
        }
    }
}

// 弹窗4：授权进度
.auth-progress-content {
    padding: 26px 32px 24px;
    text-align: center;

    .info-list {
        margin: 0 auto 20px;
        max-width: 560px;

        .info-item {
            display: grid;
            grid-template-columns: 160px 1fr;
            padding: 10px 0;
            font-size: 15px;

            .label {
                color: #808695;
                text-align: right;
                padding-right: 12px;
            }

            .value {
                color: #17233d;
                text-align: left;
            }
        }
    }

    .link-section {
        padding-top: 4px;

        .copy-hint {
            margin: 0 0 12px;
            color: #515a6e;
            font-size: 14px;
            line-height: 1.6;
        }

        .copy-link {
            color: #3f6ddc;
            cursor: pointer;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .progress-btn-wrap {
        margin-top: 6px;
        text-align: center;
    }

    .progress-btn {
        min-width: 240px;
        height: 64px;
        border-radius: 24px;
        border-width: 1px;
        font-size: 16px;
        color: #3f6ddc;
        border-color: #3f6ddc;

        &:hover {
            color: #3159c6;
            border-color: #3159c6;
        }
    }
}

// 弹窗5：提示弹窗
.tip-modal-content {
    padding: 48px;
    text-align: center;

    .tip-message {
        font-size: 16px;
        color: #17233d;
        line-height: 1.6;
        margin: 0;
    }
}

// 响应式布局
@media (max-width: 768px) {
    .upgrade-container {
        flex-direction: column;
        gap: 30px;
    }

    .upgrade-arrow-section {
        transform: rotate(90deg);
        min-width: auto;
        margin: 20px 0;
    }

    .user-panel {
        max-width: 100%;
    }

    // 弹窗响应式
    .auth-form-content,
    .org-certify-content,
    .auth-progress-content {
        padding: 16px;
    }

    .image-view-content {
        padding: 16px;

        .image-list .image-item img {
            max-width: 100%;
        }
    }

    .link-section .link-box {
        flex-direction: column;
        align-items: stretch;

        .link-text {
            margin-bottom: 8px;
        }
    }
}

// 深度选择器：修改iView组件样式
::v-deep .auth-form-modal {
    .ivu-modal {
        top: 8vh;
        padding-bottom: 0;
    }

    .ivu-modal-content {
        border-radius: 12px;
        overflow: hidden;
    }

    .ivu-modal-header {
        padding: 16px 24px;
        border-bottom: 1px solid #eef0f3;

        .ivu-modal-header-inner {
            font-size: 16px;
            font-weight: 600;
            color: #17233d;
        }
    }

    .ivu-modal-body {
        padding: 0;
        max-height: calc(72vh - 52px - 52px); /* 限高，保留 header+footer */
        overflow: auto;
        background: #fff;
    }

    .ivu-modal-footer {
        padding: 14px 24px;
        border-top: 1px solid #eef0f3;
        background: #fff;
    }
}

::v-deep .org-certify-modal {
    .ivu-modal-body {
        padding: 0;
    }

    .ivu-modal-footer {
        // padding: 0;
        border-top: 1px solid #e8eaec;
    }
}

::v-deep .image-view-modal,
::v-deep .auth-progress-modal,
::v-deep .tip-modal {
    .ivu-modal-body {
        padding: 0;
    }

    .ivu-form-item {
        margin-bottom: 20px;
    }

    .ivu-form-item-label {
        font-size: 14px;
        color: #515a6e;
    }

    .ivu-input,
    .ivu-select-selection {
        border-color: #dcdee2;
        font-size: 14px;

        &:hover {
            border-color: #4877E8;
        }

        &:focus {
            border-color: #4877E8;
            box-shadow: 0 0 0 2px rgba(72, 119, 232, 0.2);
        }
    }

    .ivu-input-large {
        height: 44px;
        font-size: 16px;
    }

    .ivu-checkbox-wrapper {
        font-size: 14px;
        color: #515a6e;
    }

    .ivu-btn {
        font-size: 14px;
        height: 36px;
        padding: 0 20px;
    }

    .ivu-btn-primary {
        background-color: #4877E8;
        border-color: #4877E8;

        &:hover {
            background-color: #3d6bd8;
            border-color: #3d6bd8;
        }

        &:disabled {
            background-color: #c5c8ce;
            border-color: #c5c8ce;
            opacity: 0.6;
        }
    }
}
</style>